/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'loading-started': {
    width: 8,
    height: 9,
    viewBox: '0 0 8 9',
    data: '<g _fill="#376F99" fill-rule="nonzero"><path pid="0" d="M3.33.103h-.514a.258.258 0 0 0-.257.257v8.267c0 .142.115.257.257.257h.514a.258.258 0 0 0 .257-.257V.36A.258.258 0 0 0 3.33.103zM5.087.103H4.83a.258.258 0 0 0-.257.257v8.267c0 .142.116.257.257.257h.257a.258.258 0 0 0 .257-.257V.36a.258.258 0 0 0-.257-.257zM7.491.103H6.206a.258.258 0 0 0-.257.257v8.267c0 .142.115.257.257.257H7.49a.258.258 0 0 0 .258-.257V.36A.258.258 0 0 0 7.49.103zM1.594.103H.31A.258.258 0 0 0 .05.36v8.267c0 .142.116.257.258.257h1.285a.258.258 0 0 0 .257-.257V.36a.258.258 0 0 0-.257-.257z"/></g>'
  }
})
